import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InfoBoxLayoutType } from 'common/questionnaires/types';

const QuestionInformationBox = ({ reference, complexReferences, correctName }) => (
  <React.Fragment>
    {reference && <div className="information-container">
      <FontAwesomeIcon icon="info-circle" className="i-info-inactive" />
      <p className="information-text"><FormattedHTMLMessage id={ reference } values={ { DerivedName: correctName } } /></p>
    </div>}
    {complexReferences && complexReferences.type === InfoBoxLayoutType.ParagraphFollowedBySingleList && <div className="information-container">
      <FontAwesomeIcon icon="info-circle" className="i-info-inactive" />
      <div className="information-text">
        <p><FormattedMessage id={ complexReferences.paragraph } /></p>
        <ul>
          {complexReferences.listReferences.map(info => <li key={ info }><FormattedMessage id={ info } values={ { DerivedName: correctName } } /> </li>)}
        </ul>
      </div>
    </div>}
  </React.Fragment>
);

QuestionInformationBox.propTypes = {
  reference: PropTypes.string,
  complexReferences: PropTypes.shape({
    type: PropTypes.number,
    paragraph: PropTypes.string,
    listReferences: PropTypes.arrayOf(PropTypes.string)
  }),
  correctName: PropTypes.string
};

QuestionInformationBox.defaultProps = {
  reference: null,
  complexReferences: null,
  correctName: ''
};

function mapStateToProps(state) {
  const {
    app: { onlineConfig },
    preQualifyingQuestionnaire: { derivedName }
  } = state;

  return {
    correctName: (derivedName !== '') ? derivedName : (onlineConfig && onlineConfig.customerName)
  };
}

export default connect(
  mapStateToProps,
)(QuestionInformationBox);
